// extracted by mini-css-extract-plugin
module.exports = {"image":"aCVzRQpA3OBpydwWIAeRm"};